import {DmsRequest} from '../common/dms-request';
import {FunctionalHeader} from '../common/functional-header';
import {TechnicalHeaderInRequest} from '../common/technical-header-in-request';
import {UserInformation} from '../common/user-information';
import {SearchCustomersRequestBody} from './search-customers-request-body';

export class SearchCustomersRequest implements DmsRequest {
  readonly simpleName = 'search-customers';
  technicalHeader: TechnicalHeaderInRequest;
  functionalHeader: FunctionalHeader;
  userInformation: UserInformation;
  body: SearchCustomersRequestBody;
}
